import { Form, notification } from "antd";
import dayjs from "dayjs";
import { authAxios } from "../../../utils/session_utils";

const useYoutubeAnalyticsHook = () => {
    const [form] = Form.useForm();

    const exportAnalytics = async () => {
        try {
            const values = await form.validateFields();
            const { options, date_range } = values;

            const [start, end] = date_range ?? [];
            const payload = {
                options: options ?? [],
                start_date: start ? dayjs(start).format("YYYY-MM-DD") : undefined,
                end_date: end ? dayjs(end).format("YYYY-MM-DD") : undefined,
            };

            const response: any = await authAxios({
                method: "POST",
                url: `${process.env.REACT_APP_BACK_END_API}/snowflake/export/youtube-analytics`,
                headers: { "Content-Type": "application/json" },
                data: JSON.stringify(payload),
            });

            const message = typeof response?.data === "string" ? response.data : "Lambda triggered";
            notification.success({
                message: "YouTube Export",
                description: message,
            });
        } catch (error: any) {
            console.error("YouTube analytics export failed:", error);
            const apiMessage = error?.response?.data?.error || error?.response?.data?.message;
            const fallbackMessage = error?.message || "Request failed";
            notification.error({
                message: "YouTube Export",
                description: apiMessage || fallbackMessage,
            });
        }
    };

    return { form, exportAnalytics };
};

export default useYoutubeAnalyticsHook;

